import { AxiosResponse } from 'axios';
import api from '../api';
import {
  IParentEventQueryParams,
  IParentEventResponse,
} from '../../interface/parentEvent.interface';

// Parent (guardian) event endpoint (CVA-4740). The base URL already includes
// `/v2`; the call is JWT-authed and the server resolves the guardian link for
// the `studentId` in the PATH. A studentId in the query is ignored server-side.

const fetchParentEvents = async (
  studentId: string,
  params?: IParentEventQueryParams,
): Promise<AxiosResponse<IParentEventResponse>> => {
  const response = await api.get<IParentEventResponse>(`/parent/events/student/${studentId}`, {
    params,
  });
  return response;
};

export const parentEventService = {
  fetchParentEvents,
};
